import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationBoxComponent } from './confirmation-box.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationBoxService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'Ok',
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm'|'lg' | 'xs' = 'xs'): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationBoxComponent, { size: dialogSize, backdrop : 'static', keyboard : false });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

}
